/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface ctaLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
}
export interface modeStruct {
  field: string;
  title ? : string;
  titleColor ? : number;
  subtitle ? : string;
  subtitleColor ? : number;
  image ? : Asset;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  ctaLink ? : Array < ctaLinkStruct > ;
  title ? : string;
  titleColor ? : number;
  subtitle ? : string;
  subtitleColor ? : number;
  product: string;
  linkTargetMode ? : string;
}
export interface itemsStruct {
  mode ? : modeStruct;
}
export default interface BigCardCarousel {
  legalTitle ? : string;
  legalText ? : string;
  enableLegalDisclaimer ? : boolean;
  titleOrSubtitle ? : string;
  topTitle ? : string;
  topTitleColor ? : number;
  subtitle ? : string;
  subtitleColor ? : number;
  items ? : Array < itemsStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  topTitle: String,
  topTitleColor: Number,
  subtitle: String,
  subtitleColor: Number,
  items: Array as() => Array < itemsStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  legalTitle: String,
  legalText: String,
  enableLegalDisclaimer: Boolean,
  titleOrSubtitle: String,
  topTitle: String,
  topTitleColor: Number,
  subtitle: String,
  subtitleColor: Number,
  items: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class BigCardCarouselBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class BigCardCarouselInstance implements BigCardCarousel {
      legalTitle ? : string;
      legalText ? : string;
      enableLegalDisclaimer ? : boolean;
      titleOrSubtitle ? : string;
      topTitle ? : string;
      topTitleColor ? : number;
      subtitle ? : string;
      subtitleColor ? : number;
      items ? : Array < itemsStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.items) {
          this.items = Object.entries(this.items)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'items' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.items.length; i1++) {

            if (this.items[i1]) {
              if (this.items[i1].mode) {
                if (typeof this.items[i1].mode.image === 'object') {
                  this.items[i1].mode.image = {
                    ...this.items[i1].mode.image,
                    link: this.items[i1].mode.image['@link'],
                    name: this.items[i1].mode.image['@name'],
                    path: this.items[i1].mode.image['@path'],
                  };
                } else {
                  this.items[i1].mode.image = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].mode) {
                if (this.items[i1].mode.mobileAspectRatio) {
                  this.items[i1].mode.mobileAspectRatio = Object.entries(this.items[i1].mode.mobileAspectRatio)
                    .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                    .map((pair: [string, any]) => ({
                      ...pair[1]
                    }));
                } else {
                  this.items[i1].mode.mobileAspectRatio = null as any;
                }
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].mode) {
                if (this.items[i1].mode.ctaLink) {
                  this.items[i1].mode.ctaLink = Object.entries(this.items[i1].mode.ctaLink)
                    .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'ctaLink' + '[0123456789]+')))
                    .map((pair: [string, any]) => ({
                      ...pair[1]
                    }));
                  for (let i2 = 0; i2 < this.items[i1].mode.ctaLink.length; i2++) {

                    if (this.items[i1]) {
                      if (this.items[i1].mode) {
                        if (this.items[i1].mode.ctaLink[i2]) {
                          if (this.items[i1].mode.ctaLink[i2].switchable) {
                            if (typeof this.items[i1].mode.ctaLink[i2].switchable.download === 'object') {
                              this.items[i1].mode.ctaLink[i2].switchable.download = {
                                ...this.items[i1].mode.ctaLink[i2].switchable.download,
                                link: this.items[i1].mode.ctaLink[i2].switchable.download['@link'],
                                name: this.items[i1].mode.ctaLink[i2].switchable.download['@name'],
                                path: this.items[i1].mode.ctaLink[i2].switchable.download['@path'],
                              };
                            } else {
                              this.items[i1].mode.ctaLink[i2].switchable.download = null as any;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  this.items[i1].mode.ctaLink = null as any;
                }
              }
            }
          }
        } else {
          this.items = null as any;
        }
      }
    }
    return new BigCardCarouselInstance(props);
  }
}
